let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9R8gx")).then(() => parcelRequire('4Kd2j'));